// extracted by mini-css-extract-plugin
module.exports = {"BannerItem":"CollectionBanner_BannerItem__1Dv7r","BannerItemImage":"CollectionBanner_BannerItemImage__2Z4d2"};